export default "/static/cellaca_tiny.png";